module.exports = __webpack_public_path__ + "static/img/PFK_Slider_New_700x400.3917ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Slider_New_700x400.jpg
// module id = 335
// module chunks = 2